"use client";

import { InputField } from "components/ui/InputField";
import { TextField } from "components/ui/TextField";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { TOTPFormValues } from "../types";

type Props = {
  errors: FieldErrors<TOTPFormValues>;
  register: UseFormRegister<TOTPFormValues>;
};

export const TOTPInputField = ({ errors, register }: Props) => {
  return (
    <InputField error={errors.totp_code} size="xs" title="認証コード" block>
      <TextField
        block
        error={errors.totp_code}
        placeholder="6桁の認証コードを入力（半角数字）"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={6}
        {...register("totp_code")}
      />
    </InputField>
  );
};
